import React from 'react';
import { AccountsTableProps } from './types';
import { styles } from './styles';
import { Table, Column } from '@v2/components';
import { Account } from '@v2/types';

const columns: Column<Account>[] = [
  {
    key: 'name',
    header: 'Name',
    sortKey: 'firstName',
    render: (row) => (
      <div className={styles.nameContainer}>
        <div className={styles.avatar}>
          {row.firstName?.charAt(0)}{row.lastName?.charAt(0)}
        </div>
        <span className={styles.name}>
          {row.firstName} {row.lastName}
        </span>
      </div>
    ),
  },
  {
    key: 'email',
    header: 'Email',
    sortKey: 'email',
    render: (row) => (
      <span className={styles.email}>
        {row.email}
      </span>
    ),
  },
];

const AccountsTable: React.FC<AccountsTableProps> = ({
  accounts,
  loading,
  error,
  onSelectAccount,
  selectedAccountId,
  sortConfig,
  onSortChange,
}) => {
  if (error) {
    return (
      <div className={styles.errorContainer}>
        <p className={styles.error}>{error}</p>
      </div>
    );
  }

  return (
    <Table<Account>
      columns={columns}
      data={accounts}
      keyExtractor={(account) => account.id}
      loading={loading}
      emptyMessage="No accounts found."
      onRowClick={onSelectAccount}
      selectedKeys={selectedAccountId ? [selectedAccountId] : []}
      maxHeight="calc(100vh - 200px)"
      sortConfig={sortConfig ?? null}
      onSortChange={onSortChange}
    />
  );
};

export default AccountsTable;
